import { saveToLocalStorage } from "pianofunclub-crm/utils/localStorage";

import type { RefreshAccessTokenMutation$data } from "pianofunclub-shared/relay/graphql/auth/__generated__/RefreshAccessTokenMutation.graphql";

export const refreshAccessToken = async (variables: {
  clientSideLogout: () => void;
  fetchUrl: string;
  refreshToken: string;
  refreshTokenExpiresAt: number;
}): Promise<string> => {
  const { clientSideLogout, fetchUrl, refreshToken, refreshTokenExpiresAt } = variables;

  const currentUnixTime = Math.floor(Date.now() / 1000);

  // if the refresh token is expired, log the user out
  if (refreshToken && refreshTokenExpiresAt && refreshTokenExpiresAt < currentUnixTime) {
    clientSideLogout();
    return Promise.resolve("");
  }

  const refresh_access_token = `mutation RefreshAccessTokenMutation($refreshToken: String) {
        refreshAccessToken(refreshToken: $refreshToken) {
            token
            payload
            refreshToken
            refreshExpiresIn
        }
    }`;

  // we have to fire this without the relay environment because this is
  // executed within the relay nework layer config
  const rawResponse = await fetch(fetchUrl, {
    body: JSON.stringify({
      variables: {
        refreshToken,
      },
      query: refresh_access_token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  const response: RefreshAccessTokenMutation$data = (await rawResponse.json())?.data;

  if (!response?.refreshAccessToken?.token) {
    clientSideLogout();
    return Promise.resolve("");
  }

  const newAccessToken = response.refreshAccessToken.token;
  const newAccessTokenExpiresAt = response.refreshAccessToken.payload.exp;
  const newRefreshToken = response.refreshAccessToken.refreshToken;
  const newRefreshTokenExpiresAt =
    // variable on JWT mutation response is confusingly named (it is NOT the time until expiry)
    response.refreshAccessToken.refreshExpiresIn;

  saveToLocalStorage("token", newAccessToken);
  saveToLocalStorage("token_expires_at", newAccessTokenExpiresAt.toString());
  saveToLocalStorage("refresh_token", newRefreshToken);
  saveToLocalStorage("refresh_token_expires_at", newRefreshTokenExpiresAt.toString());

  return Promise.resolve(newAccessToken);
};
